<mat-drawer-container id="customers_add_edit_main_container" autosize>
  <mat-card id="customers_add_edit_mat_card">
    <mat-card-content class="form-mat-card-content">
      @if (!loading() && !formPrepareError()) {
        <form
          id="customer_form"
          class="custom-form grid-form custom-form-in-tab"
          [formGroup]="customerForm">
          <div id="customers_add_edit_name">
            <div id="form_input_title_name" class="form-input-title">Customer Name:</div>
            <mat-form-field id="customer_name_field" class="form-field-custom form-field-input">
              <input
                matInput
                id="customer_name_input"
                maxlength="50"
                class="shared-input-field"
                formControlName="name"
                autocomplete="off"
                (focus)="onInputFocus('name')"
                (blur)="onInputBlur('name')" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                (customerForm.controls['name'].touched &&
                  customerForm.controls['name'].errors !== null &&
                  !focusState()['name']) ||
                customerForm.controls['name'].hasError('isNotUnique')
              ) {
                <mat-error id="customer_name_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('name') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_add_edit_key" class="position-relative">
            <div id="form_input_title_key" class="form-input-title">Customer Key:</div>
            <mat-form-field id="customer_key_field" class="form-field-custom form-field-input">
              <input
                id="customer_key_input"
                class="shared-input-field lowercase-input"
                matInput
                maxlength="50"
                formControlName="tenantKey"
                autocomplete="off"
                (input)="trimFieldAndLowerCase('tenantKey')"
                (focus)="onInputFocus('tenantKey')"
                (blur)="onInputBlur('tenantKey')" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                (customerForm.controls['tenantKey'].touched &&
                  customerForm.controls['tenantKey'].errors !== null &&
                  !focusState()['tenantKey']) ||
                customerForm.controls['tenantKey'].hasError('isNotUnique')
              ) {
                <mat-error id="customer_key_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('tenantKey') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_add_edit_contact">
            <div id="form_input_title_contact" class="form-input-title">Customer Contact:</div>
            <mat-form-field
              class="form-field-custom  {{
                pageType() === action.create ? 'form-field-input' : 'add-edit-dropdown'
              }} "
              id="customer_contact_field">
              @if (pageType() === action.create) {
                <span>
                  <input
                    matInput
                    id="customer_email_input"
                    class="shared-input-field"
                    formControlName="email"
                    autocomplete="off"
                    (input)="trimFieldAndLowerCase('email')"
                    (focus)="onInputFocus('email')"
                    (blur)="onInputBlur('email')" />
                </span>
              }
              @if (pageType() === action.edit) {
                <span>
                  <mat-select
                    #singleSelect
                    id="customer_owner_dropdown"
                    placeholder="Select Customer Owner"
                    formControlName="email">
                    @for (fleetManager of fleetManagers(); track fleetManager) {
                      <mat-option
                        id="fleet_manager_{{ fleetManager }}"
                        [value]="fleetManager.email"
                        (click)="selectNewCustomerOwner(fleetManager)">
                        {{ fleetManager.email }}
                      </mat-option>
                    }
                  </mat-select>
                </span>
              }
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                (customerForm.controls['email'].touched &&
                  customerForm.controls['email'].errors !== null &&
                  !focusState()['email']) ||
                customerForm.controls['email'].hasError('isNotUnique')
              ) {
                <mat-error id="customer_contact_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('email') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_add_edit_timezone">
            <div id="form_input_title_timezone" class="form-input-title">Timezone:</div>
            <mat-form-field
              id="customer_timezone_field"
              class="form-field-custom add-edit-dropdown">
              <mat-select
                id="timezone_select"
                formControlName="timezone"
                placeholder="Select Time Zone">
                <mat-option id="searchOption">
                  <ngx-mat-select-search
                    id="time_zone_search"
                    placeholderLabel="Search..."
                    noEntriesFoundLabel="None Found!"
                    [formControl]="timeZoneSearch"
                    (input)="filterTimeZones(timeZoneSearch.value)">
                  </ngx-mat-select-search>
                </mat-option>
                @for (zone of timeZones(); track zone) {
                  <mat-option id="customer_timezone_options_{{ zone }}" [value]="zone">
                    {{ zone }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                customerForm.controls['timezone'].touched &&
                !customerForm.controls['timezone'].valid &&
                !focusState()['timezone']
              ) {
                <mat-error id="customer_timezone_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('timezone') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_add_edit_first_name">
            <div id="form_input_title_first_name" class="form-input-title">First Name:</div>
            <mat-form-field
              id="customer_first_name_field"
              class="form-field-custom form-field-input">
              <input
                matInput
                id="customer_first_name_input"
                maxlength="50"
                class="shared-input-field"
                formControlName="firstName"
                autocomplete="off" />
              <span class="error-space-holder">
                @if (
                  customerForm.controls['firstName'].touched &&
                  !customerForm.controls['firstName'].valid &&
                  !focusState()['firstName']
                ) {
                  <mat-error id="customer_first_name_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('firstName') }}
                  </mat-error>
                }
              </span>
            </mat-form-field>
          </div>
          <div id="customers_add_edit_last_name">
            <div id="form_input_title_last_name" class="form-input-title">Last Name:</div>
            <mat-form-field
              id="customer_last_name_field"
              class="form-field-custom form-field-input">
              <input
                matInput
                id="customer_last_name_input"
                maxlength="50"
                class="shared-input-field"
                formControlName="lastName"
                autocomplete="off" />
              <span class="error-space-holder">
                @if (
                  customerForm.controls['lastName'].touched &&
                  !customerForm.controls['lastName'].valid &&
                  !focusState()['lastName']
                ) {
                  <mat-error id="last_name_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('lastName') }}
                  </mat-error>
                }
              </span>
            </mat-form-field>
          </div>
          <div id="customers_add_edit_stack" class="position-relative">
            <div id="form_input_title_stack" class="form-input-title">Stack:</div>
            <mat-form-field
              id="customer_stack_field"
              class="form-field-custom add-edit-dropdown pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="!customerForm.get('stack')?.disabled"
              (click)="
                pageType() === action.edit &&
                  customerForm.get('stack')?.disabled &&
                  areYouSureKey(restrictedCustomerProperty.stack)
              ">
              <mat-select
                id="stack_select"
                placeholder="Select Stack"
                formControlName="stack"
                [compareWith]="compareStacks">
                @for (stack of stacks(); track stack) {
                  <mat-option id="customer_stack_options_{{ stack }}" [value]="stack">
                    {{ stack.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                customerForm.controls['stack'].touched &&
                !customerForm.controls['stack'].valid &&
                !focusState()['stack']
              ) {
                <mat-error id="customer_stack_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('stack') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_add_edit_vehicle_intelligence_url" class="position-relative">
            <div id="form_input_title_vehicle_intelligence_url" class="form-input-title">
              Vehicle Intelligence:
            </div>
            <mat-form-field
              id="customer_vehicle_intelligence_url_field"
              class="form-field-custom form-field-input pointer"
              (click)="
                pageType() === action.edit &&
                  !isViUrlEnabled() &&
                  areYouSureKey(restrictedCustomerProperty.viUrl)
              ">
              <input
                matInput
                id="customer_vehicle_intelligence_url_input"
                maxlength="50"
                class="shared-input-field vehicle-intelligence-url-input"
                formControlName="vehicleIntelligenceUrl"
                autocomplete="off"
                matTooltip="Are you sure you want to edit?"
                [matTooltipShowDelay]="500"
                [matTooltipDisabled]="isViUrlEnabled()"
                [ngClass]="{ 'read-only-input': !isViUrlEnabled() }"
                [readonly]="pageType() === action.edit && !isViUrlEnabled()" />
              <span class="url-trail"> .trackingavl.com</span>
              <span class="error-space-holder">
                @if (
                  customerForm.controls['vehicleIntelligenceUrl'].touched &&
                  !customerForm.controls['vehicleIntelligenceUrl'].valid &&
                  !focusState()['vehicleIntelligenceUrl']
                ) {
                  <mat-error id="vehicle_intelligence_url_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('vehicleIntelligenceUrl') }}
                  </mat-error>
                }
              </span>
            </mat-form-field>
          </div>
          <div id="customers_app_prefix" class="position-relative">
            <div id="form_input_title_fi_prefix" class="form-input-title">
              Application Region Prefix:
            </div>
            <mat-form-field
              id="app_prefix_field"
              class="form-field-custom form-field-input pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="isAppPrefixEnabled()"
              (click)="
                pageType() === action.edit &&
                  !isAppPrefixEnabled() &&
                  areYouSureKey(restrictedCustomerProperty.appPrefix)
              ">
              <input
                class="shared-input-field lowercase-input"
                matInput
                id="app_prefix_input"
                maxlength="20"
                formControlName="appRegionPrefix"
                autocomplete="off"
                [ngClass]="{ 'read-only-input': !isAppPrefixEnabled() }"
                [readonly]="pageType() === action.edit && !isAppPrefixEnabled()"
                (input)="
                  customerForm.patchValue({ appRegionPrefix: $event.target.value.toLowerCase() })
                "
                (focus)="onInputFocus('appRegionPrefix')"
                (blur)="onInputBlur('appRegionPrefix')" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                (customerForm.controls['appRegionPrefix'].touched &&
                  customerForm.controls['appRegionPrefix'].errors !== null &&
                  !focusState()['appRegionPrefix']) ||
                customerForm.controls['appRegionPrefix'].hasError('isNotUnique')
              ) {
                <mat-error id="app_prefix_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('appRegionPrefix') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="customers_bi_region">
            <div id="form_input_title_bi_region" class="form-input-title">
              Business Intelligence Region:
            </div>
            <mat-form-field
              id="customer_bi_region_field"
              class="form-field-custom add-edit-dropdown pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="!customerForm.get('biRegion')?.disabled"
              (click)="
                pageType() === action.edit &&
                  customerForm.get('biRegion')?.disabled &&
                  areYouSureKey(restrictedCustomerProperty.biRegion)
              ">
              <mat-select
                id="bi_region_select"
                formControlName="biRegion"
                placeholder="Select Business Intelligence Region">
                @for (region of awsRegionsList(); track region) {
                  <mat-option id="customer_bi_region_options_{{ region }}" [value]="region.code">
                    {{ region.code }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                customerForm.controls['biRegion'].touched &&
                !customerForm.controls['biRegion'].valid &&
                !focusState()['biRegion']
              ) {
                <mat-error id="customer_bi_region_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('biRegion') }}
                </mat-error>
              }
            </span>
          </div>
          <div>
            <div id="form_input_title_idp" class="form-input-title">
              Identity Provider:
              <span
                matTooltip="Enabling IDP will disable user creation in Portal"
                [matTooltipShowDelay]="500">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
            <mat-form-field
              class="form-field-custom add-edit-dropdown pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="!customerForm.get('hasIdentityProvider')?.disabled"
              (click)="
                pageType() === action.edit &&
                  customerForm.get('hasIdentityProvider')?.disabled &&
                  areYouSureKey(restrictedCustomerProperty.idp)
              ">
              <mat-select formControlName="hasIdentityProvider">
                @for (value of active; track value) {
                  <mat-option id="idp_option{{ value }}" [value]="value === 'Enabled'">
                    {{ value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder"> </span>
          </div>
          @if (
            pageType() === action.edit &&
            ([accessRight.DeletePasswords] | allRights) &&
            customer()?.hasIdentityProvider === true
          ) {
            <div id="customers_add_edit_clear_passwords" class="position-relative">
              <div class="title-button-row">
                <span id="delete_password_text" class="delete-password-text">
                  Delete IDP Passwords:
                </span>
                <span class="spacer"></span>
                <span
                  matTooltipPosition="right"
                  [matTooltip]="
                    domainsChanged() ? 'Cannot delete passwords while Domains are being edited' : ''
                  "
                  [matTooltipDisabled]="!domainsChanged()"
                  [matTooltipShowDelay]="500">
                  <button
                    mat-button
                    class="delete-button delete-passwords-button"
                    [disabled]="domainsChanged()"
                    (click)="clearPasswords()">
                    DELETE
                  </button>
                </span>
              </div>
            </div>
          }
          <div id="customers_add_edit_applications" class="position-relative">
            <div id="form_input_title_applications" class="form-input-title">Applications:</div>
            <mat-form-field
              id="customer_applications_field"
              class="form-field-custom add-edit-dropdown pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="isApplicationsEnabled()"
              (click)="
                pageType() === action.edit &&
                  !isApplicationsEnabled() &&
                  areYouSureKey(restrictedCustomerProperty.applications)
              ">
              <mat-select
                id="applications_select"
                placeholder="Select Applications"
                multiple
                [value]="selectedApplicationOptions()"
                [disabled]="!isApplicationsEnabled()"
                (selectionChange)="onApplicationOptionSelected($event.value)">
                @for (app of applicationOptions; track app) {
                  <mat-option id="app_dropdown_{{ app }}" [value]="app">
                    {{ app }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder"> </span>
          </div>
          <div class="position-relative">
            <div id="form_input_title_integrations" class="form-input-title">Integrations:</div>
            <mat-form-field
              class="form-field-custom add-edit-dropdown pointer"
              matTooltip="Are you sure you want to edit?"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="isIntegrationsEnabled()"
              (click)="
                pageType() === action.edit &&
                  !isIntegrationsEnabled() &&
                  areYouSureKey(restrictedCustomerProperty.integrations)
              ">
              <mat-select
                placeholder="Select Integrations"
                multiple
                [value]="selectedIntegrationOptions()"
                [disabled]="!isIntegrationsEnabled()"
                (selectionChange)="onIntegrationsOptionSelected($event.value)">
                @for (integration of integrationOptions; track integration) {
                  <mat-option id="app_dropdown_{{ integration }}" [value]="integration.label">
                    {{ integration.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder"> </span>
          </div>
          <div id="customers_add_edit_enabled" class="position-relative">
            <div id="form_input_title_enabled" class="form-input-title">Billing Status:</div>
            <mat-form-field id="customer_enabled_field" class="form-field-custom add-edit-dropdown">
              <mat-select id="enabled_select" formControlName="status">
                @for (option of customerStatusOptions(); track option) {
                  <mat-option id="enabled_dropdown_{{ option }}" [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder"> </span>
          </div>

          <div class="position-relative">
            <div id="form_input_title_domains" class="form-input-title">Domains:</div>
            <div class="form-field-custom form-field-input">
              @for (
                domainControl of customerFormDomains.controls;
                track domainControl;
                let i = $index
              ) {
                <div class="input-item">
                  <mat-form-field
                    id="customer_domain_{{ i }}_field"
                    class="form-field-custom form-field-input">
                    <input
                      id="customer_domain_{{ i }}_input"
                      matInput
                      maxlength="50"
                      class="shared-input-field"
                      autocomplete="off"
                      [formControl]="domainControl" />
                    <span class="error-space-holder">
                      @if (
                        domainControl.touched &&
                        !domainControl.valid &&
                        domainControl.hasError('domainName')
                      ) {
                        <mat-error id="customer_domain_{{ i }}_error" class="error input-error">
                          <i class="fas fa-exclamation-triangle error-icon"></i>Domain name is
                          invalid or empty
                        </mat-error>
                      }
                    </span>
                  </mat-form-field>
                  <button
                    id="customers_remove_domain_{{ i }}_button"
                    mat-button
                    class="delete-button"
                    [disabled]="i === 0"
                    (click)="removeDomain(i)">
                    Delete
                  </button>
                </div>
              }
              <div class="add-domain-button-container">
                <span class="error-space-holder">
                  @if (
                    !customerFormDomains.valid && customerFormDomains.hasError('domainsTotalChars')
                  ) {
                    <mat-error id="customers_domains_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i>Total domains characters
                      limit exceeded
                    </mat-error>
                  }
                </span>
                <button
                  mat-button
                  id="customers_add_domain_button"
                  class="save-button"
                  (click)="addDomain()">
                  Add <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div id="customers_add_edit_cancel_2" class="buttons-row span-all-cols">
            <button
              mat-button
              id="customers_add_edit_cancel_2"
              class="add-edit-button white-button"
              routerLink="/customers">
              Cancel
            </button>
            <button
              mat-button
              id="customers_add_edit_save_2"
              class="add-edit-button save-button"
              [ngClass]="{ 'invalid-button': !customerForm.valid }"
              (click)="onSubmit()">
              Save
            </button>
          </div>
        </form>
      }
      @if (formPrepareError()) {
        <app-form-error class="higher-display" />
      } @else if (loading()) {
        <app-loading-spinner class="higher-display" />
      }
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
